import RoleHome from '../RoleHome';

export default function DataAnalystPage() {
  return (
    <RoleHome
      title="Data analyst"
      description="Analytics with controlled patient read access."
    />
  );
}
